import { TopicType } from '@api';
import { getTimeTillEndOfDayMs } from '@helpers';
import { useQuery } from '@tanstack/react-query';
import { getTopic } from '@terminal/services/topics/topics-service';

import { QUERY_KEY_FOLLOWED_TOPICS } from './useFollowedTopics';

export const useFollowedTopic = (type: TopicType, code: string) =>
  useQuery({
    queryKey: [QUERY_KEY_FOLLOWED_TOPICS, type, code],
    queryFn: ({ signal }) => getTopic(type, code, signal),
    staleTime: getTimeTillEndOfDayMs(),
  });
